export class StorageKey {
    static readonly setting = 'setting'
    static readonly user = 'Constants.user'
}
